// extracted by mini-css-extract-plugin
module.exports = {"ButtonWrap":"ReportsRoute_ButtonWrap__KtiE-","UploadDesktop":"ReportsRoute_UploadDesktop__2IIz8"};